import React from "react";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid";

const Calender = () => {
  return (
    <div className="border ">
      <FullCalendar
        plugins={[dayGridPlugin]}
        initialView="dayGridMonth"
        weekends={false}
        events={[
          {
            title: 'Eid vacation',
            start: '2022-10-14T10:30:00',
            end: '2022-10-17T11:30:00',
            extendedProps: {
              department: 'Close'
            },
            description: 'Eid vacation'
          }
        ]}
      />
    </div>
  );
};

export default Calender;
